import React from 'react';
import { Divider, List } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import FuseNavVerticalGroup from './vertical/FuseNavVerticalGroup';
import FuseNavVerticalCollapse from './vertical/FuseNavVerticalCollapse';
import FuseNavVerticalLink from './vertical/FuseNavVerticalLink';
import FuseNavHorizontalGroup from './horizontal/FuseNavHorizontalGroup';
import FuseNavHorizontalCollapse from './horizontal/FuseNavHorizontalCollapse';
import FuseNavHorizontalItem from './horizontal/FuseNavHorizontalItem';
import FuseNavVerticalButton from './vertical/FuseNavVerticalButton';
import FuseNavHorizontalLink from './horizontal/FuseNavHorizontalLink';
import NavigationItem from './vertical/NavigationItem';
import { usePlace } from 'commons/usePlace';

function FuseNavigation(props) {
  const { navigation, layout = 'vertical', active, dense, className } = props;
  const place = usePlace();

  const verticalNav = (
    <List className={clsx('navigation', className)}>
      {navigation.map(item => (
        <React.Fragment key={item.id}>
          {item.type === 'group' && (
            <FuseNavVerticalGroup item={item} nestedLevel={0} active={active} dense={dense} />
          )}

          {item.type === 'collapse' && item.id !== 'plans-and-billing' ? (
            <FuseNavVerticalCollapse item={item} nestedLevel={0} active={active} dense={dense} />
          ) : null}

          {item.type === 'collapse' &&
          item.id === 'plans-and-billing' &&
          !place.billingPageDisabled ? (
            <FuseNavVerticalCollapse item={item} nestedLevel={0} active={active} dense={dense} />
          ) : null}

          {item.type === 'item' && (
            <NavigationItem item={item} nestedLevel={0} active={active} dense={dense} />
          )}

          {item.type === 'link' && (
            <FuseNavVerticalLink item={item} nestedLevel={0} active={active} dense={dense} />
          )}

          {item.type === 'button' && (
            <FuseNavVerticalButton item={item} nestedLevel={0} active={active} dense={dense} />
          )}

          {item.type === 'divider' && <Divider className="my-16" />}
        </React.Fragment>
      ))}
    </List>
  );

  const horizontalNav = (
    <List className={clsx('navigation whitespace-nowrap flex p-0', className)}>
      {navigation.map(item => (
        <React.Fragment key={item.id}>
          {item.type === 'group' && (
            <FuseNavHorizontalGroup item={item} nestedLevel={0} dense={dense} />
          )}

          {item.type === 'collapse' && (
            <FuseNavHorizontalCollapse item={item} nestedLevel={0} dense={dense} />
          )}

          {item.type === 'item' && (
            <FuseNavHorizontalItem item={item} nestedLevel={0} dense={dense} />
          )}

          {item.type === 'link' && (
            <FuseNavHorizontalLink item={item} nestedLevel={0} dense={dense} />
          )}

          {item.type === 'divider' && <Divider className="my-16" />}
        </React.Fragment>
      ))}
    </List>
  );

  if (navigation.length > 0) {
    switch (layout) {
      case 'horizontal': {
        return horizontalNav;
      }
      case 'vertical':
      default: {
        return verticalNav;
      }
    }
  } else {
    return null;
  }
}

FuseNavigation.propTypes = {
  navigation: PropTypes.array.isRequired,
};


export default React.memo(FuseNavigation);
